import store from "store";
import { ALL_ARTICLES_IN_EDITION } from "constants/actionTypes";
import { IArticlesItem } from "modules/Content/interfaces";
import { serializeArticles } from "modules/Content/WhatsHappeningNow/utils";
import {
  getEditionArticlesService,
  updateEditionNameService,
  updateEditionSubjectService,
} from "modules/Services/AssetService";
import {
  ASSET_DETAILS,
  ASSET_DETAILS_UPDATE_DRAFT,
  ASSET_WITHOUT_CAMPAIGN_DETAILS,
  CAMPAIGN_SENT_EDITIONS,
  EDITION_NAME_CHANGE,
} from "constants/types";
import { storeLoading } from "modules/Analytics/utils";
import { saveSentAsDraftEditionCampaignService } from "modules/Services/CampaignsService";

export const resetEditionArticles = () => {
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.RESET,
  });
};

//* Fetch articles of a particular edition using
export const getEditionArticles = (versionId: any) => {
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.LOAD,
  });
  getEditionArticlesService(versionId)
    .then((res: any) => {
      // console.log("res: getEditionArticles ", res);
      const serializedData: IArticlesItem[] = serializeArticles(res.data.version_content);
      store.dispatch({
        type: ALL_ARTICLES_IN_EDITION.LOAD_SUCCESS,
        payload: {
          list: serializedData,
          editionName: res.data.version_name,
          templateId: res.data.version_template_id,
          editionStatus: res.data.version_status,
          adminId: res.data.admin_id,
          userId: res.data.user_id,
          assetId: res.data.asset_id,
          editionId: res.data.version_id,
          subject: res.data.version_subject,
          campaignName: res.data.campaign_name,
          digestName: res.data.asset_name,
          emailType: res.data.email_type,
          editionLastUpdate: res.data.version_updated_on,
          workflowCurrentState: res.data.workflow_current_state,
          workflowStatus: res.data.workflow_status,
          workflowId: res.data.workflow_id,
          workflowName: res.data.workflow_name,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: ALL_ARTICLES_IN_EDITION.LOAD_FAIL,
        payload: [],
      });
    });
};

export const updateEditionSubject = (versionId: number, subject: string, callback?: any) => {
  store.dispatch({
    type: CAMPAIGN_SENT_EDITIONS.SET_VERSION_SUBJECT_LOADING,
  });
  updateEditionSubjectService(versionId, subject)
    .then((res: any) => {
      if (res.status === 200) {
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.SUBJECT_UPDATE,
          payload: subject,
        });
        store.dispatch({
          type: CAMPAIGN_SENT_EDITIONS.SET_VERSION_SUBJECT_SUCCESS,
          payload: { versionId, subject },
        });
        store.dispatch({
          type: ASSET_WITHOUT_CAMPAIGN_DETAILS.SET_DRAFT_NAME,
          payload: { versionId, subject },
        });
        store.dispatch({
          type: CAMPAIGN_SENT_EDITIONS.LOADER_HIDE,
        });
        store.dispatch({
          type: EDITION_NAME_CHANGE.SUCCESS,
          payload: { versionId, name: subject },
        });
        store.dispatch({
          type: ASSET_DETAILS.UPDATE_SUBJECT,
          payload: { versionId, subject },
        });

        store.dispatch({
          type: ASSET_DETAILS_UPDATE_DRAFT.SET_VERSION_SUBJECT_SUCCESS,
          payload: { versionId, subject },
        });

        if (callback) callback(false);
      }
    })
    .catch((error: any) => {
      store.dispatch({
        type: CAMPAIGN_SENT_EDITIONS.LOADER_HIDE,
      });
      console.log("couldn't update subject for version id : ", error);
    });
};

export const editionNameChange = (versionId: any, name: string) => {
  console.log("update edition name action");
  store.dispatch({ type: EDITION_NAME_CHANGE.LOAD });
  updateEditionNameService(versionId, name)
    .then((res: any) => {
      if (res.status === 200) {
        store.dispatch({
          type: EDITION_NAME_CHANGE.SUCCESS,
          payload: { versionId, name },
        });
        setTimeout(() => {
          store.dispatch({ type: EDITION_NAME_CHANGE.RESET });
        }, 3000);
      }
    })
    .catch((error: any) => {
      store.dispatch({ type: EDITION_NAME_CHANGE.FAIL });
      console.log("couldn't update subject for version id : ", error);
    });
};

export const saveSentEmailAsDraft = (campaignId: any, emailId: any) => {
  // storeLoading(ASSET_DETAILS_ADD_NEW_DRAFT.LOAD);
  return saveSentAsDraftEditionCampaignService(campaignId, emailId);
  // .then(({ data }: any) => {
  //   const date = new Date();
  //   const newDraftEdition = {
  //     version_id: data?.id,
  //     name: data?.name,
  //     status: "draft",
  //     last_update: date.getDate() + " " + date.getMonth(),
  //     sent_date: data?.creation_time.length > 8 ? null : data.creation_time,
  //     thumbnail: [],
  //     total_contacts: 0,
  //     total_sent: 0,
  //     total_delivery: 0,
  //     total_open: 0,
  //     total_clicks: 0,
  //     curated_articles_count: 0,
  //     a_or_b: "a",
  //     description: "",
  //     title: "",
  //     link: "",
  //     cloned: true,
  //   };
  //   store.dispatch({
  //     type: ASSET_DETAILS_ADD_NEW_DRAFT.SUCCESS,
  //     newDraft: newDraftEdition,
  //   });
  // })
  // .catch((err: any) => {
  //   console.log(err);
  //   store.dispatch({
  //     type: ASSET_DETAILS_ADD_NEW_DRAFT.FAIL,
  //     payload: [],
  //   });
  // });
};

export const setEditionEmailId = (emailId: number) => {
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.SET_EMAIL_ID,
    payload: emailId,
  });
};

export const resetEditionData = () => {
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.RESET_ALL_EDITION_DATA,
  });
};

export const updateEmailCampaignState = () => {
  store.dispatch({ type: ALL_ARTICLES_IN_EDITION.UPDATE_CAMPAIGN_STATE, payload: false });
};

export const updateWorkflowCurrentState = (currentState: string) => {
  store.dispatch({ type: ALL_ARTICLES_IN_EDITION.UPDATE_WORKFLOW_CURRENT_STATE, payload: currentState });
};
